import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=6ecd530d&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ecd530d')) {
      api.createRecord('6ecd530d', component.options)
    } else {
      api.reload('6ecd530d', component.options)
    }
    module.hot.accept("./EmptyLayout.vue?vue&type=template&id=6ecd530d&", function () {
      api.rerender('6ecd530d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EmptyLayout.vue"
export default component.exports